module.exports = __webpack_public_path__ + "images/application/i-modes-0a5f00c9.svg";